import React, { useEffect, useState } from "react";
import { useCart } from "../CartContext";
import { supabase } from "../lib/supabaseClient.ts";
import emailjs from 'emailjs-com';

const CheckoutPage = ({ onPlaceOrder }) => {
  const { cart,clearCart } = useCart();
useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);
const [deliveryMethod, setDeliveryMethod] = useState("domicile"); // "domicile" or "magasin"

  // Fix price scale from millimes to dinars
// Convert raw price (millimes) to dinars
const parsePrice = (price) => {
  const parsed = parseFloat(String(price).replace(/[^\d.-]/g, ''));
  if (isNaN(parsed)) return 0;

  // Case 1: Huge mis-scaled prices → divide by 1_000_000
  if (parsed > 1000000000) return parsed / 1_000_000_000;

  // Case 2: Millime prices → divide by 1000
  if (parsed >= 1000) return parsed / 1000;

  // Case 3: Already in dinars
  return parsed;
};

// Format price for display (French style, thousands separator)
const formatPrice = (price) => {
  if (price == null) return "0";
  
  // Format number normally with 3 decimals
  const formatted = new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: 3,  // Show 3 decimal places
    maximumFractionDigits: 3,  // No rounding, show up to 3 decimal places
  }).format(Number(price));

  return `${formatted}`;  // Adding currency symbol
};


const subtotal = Array.isArray(cart)
  ? cart.reduce((sum, item) => {
      const price = parsePrice(item.selectedPrice || 0);
      const qty = Number(item.quantity) || 1;
      return sum + price * qty;
    }, 0)
  : 0;

const deliveryFee = deliveryMethod === "domicile" ? parsePrice(8000) : 0;
const total = subtotal + deliveryFee;

  // Form state
  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    adresse: "",
    ville: "",
    gouvernorat: "",
    codePostal: "",
    tel1: "",
    tel2: "",
    email: "",
  });

  // Confirmation state
  const [isConfirmed, setIsConfirmed] = useState(false);


// const saveOrder = async (formData, cart, subtotal, deliveryFee, total) => {
//   try {
//     // Sanitize cart for JSON column: only keep relevant data
//     const cleanedCart = cart.map((item) => ({
//       id: item.id,
//       name: item.name,
//       quantity: item.quantity,
//       selectedPrice: parseFloat(item.selectedPrice),
//       total: parseFloat(item.selectedPrice) * item.quantity,
//     }));

//   const orderData = {
//   nom: formData.nom,
//   prenom: formData.prenom,
//   adresse: formData.adresse,
//   ville: formData.ville,
//   gouvernorat: formData.gouvernorat,
//   code_postal: formData.codePostal,
//   tel1: formData.tel1,
//   tel2: formData.tel2 || null,
//   email: formData.email,
//   sous_total: parseFloat(subtotal),
//   frais_livraison: parseFloat(deliveryFee),
//   total: parseFloat(total),
//   statut: "en_attente", // <-- Utiliser la valeur exacte attendue dans la contrainte
//   items: cleanedCart,
// };


//     const { data, error } = await supabase
//       .from("commandes_clients")
//       .insert([orderData])
//       .select();

//     if (error) {
//       console.error("Erreur Supabase:", error);
//       alert("Échec de la commande. Vérifiez les champs ou réessayez plus tard.");
//     } else {
//       console.log("Commande enregistrée:", data);
//           // ✅ Vider le panier ici
//         clearCart();


//       // Optionnel : redirection ou message de succès
//       alert("Commande enregistrée avec succès !");
//     }
//   } catch (err) {
//     console.error("Erreur inattendue:", err);
//   }
// };
// const saveOrder = async (formData, cart, subtotal, deliveryFee, total) => {
//   try {
//     // ✅ Sanitize cart for JSON storage
//     const cleanedCart = cart.map((item) => ({
//       id: item.id,
//       name: item.name,
//       quantity: item.quantity,
//       selectedPrice: parseFloat(item.selectedPrice),
//       total: parseFloat(item.selectedPrice) * item.quantity,
//     }));

//     // ✅ Build order data
//     const orderData = {
//       nom: formData.nom,
//       prenom: formData.prenom,
//       adresse: formData.adresse,
//       ville: formData.ville,
//       gouvernorat: formData.gouvernorat,
//       code_postal: formData.codePostal,
//       tel1: formData.tel1,
//       tel2: formData.tel2 || null,
//       email: formData.email,
//       sous_total: parseFloat(subtotal),
//       frais_livraison: parseFloat(deliveryFee),
//       total: parseFloat(total),
//       statut: "en_attente",
//       items: cleanedCart,
//     };

//     // ✅ Insert order into Supabase
//     const { data, error } = await supabase
//       .from("commandes_clients")
//       .insert([orderData])
//       .select();

//     if (error) {
//       console.error("Erreur Supabase:", error);
//       return { success: false, message: "Erreur lors de l’enregistrement de la commande." };
//     }

//     console.log("Commande enregistrée:", data);
//     // ✅ Optionally clear the cart after success
//     clearCart();

//     // ✅ Return success
//     return { success: true, data };
//   } catch (err) {
//     console.error("Erreur inattendue:", err);
//     return { success: false, message: "Erreur inattendue lors de la commande." };
//   }
// };
const saveOrder = async (formData, cart, subtotal, deliveryFee, total) => {
  try {
    // ✅ Include variations (Goût & Poids)
    const cleanedCart = cart.map((item) => ({
      id: item.id,
      name: item.name,
      quantity: item.quantity,
      selectedPrice: parseFloat(item.selectedPrice),
      total: parseFloat(item.selectedPrice) * item.quantity,
      image: item.image || null,
      selectedGout: item.selectedGout || null,   // ✅ keep exact property names
      selectedWeight: item.selectedWeight || null, // ✅ same here
    }));

    const orderData = {
      nom: formData.nom,
      prenom: formData.prenom,
      adresse: formData.adresse,
      ville: formData.ville,
      gouvernorat: formData.gouvernorat,
      code_postal: formData.codePostal,
      tel1: formData.tel1,
      tel2: formData.tel2 || null,
      email: formData.email,
      sous_total: parseFloat(subtotal),
      frais_livraison: parseFloat(deliveryFee),
      total: parseFloat(total),
      statut: "en_attente",
      items: cleanedCart, // 🧺 includes variations now
    };

    // 🧠 Debug
    console.log("🛒 Items to be saved:", cleanedCart);
    console.log("📦 Full order data:", orderData);

    const { data, error } = await supabase
      .from("commandes_clients")
      .insert([orderData])
      .select();

    if (error) {
      console.error("Erreur Supabase:", error);
      return { success: false, message: "Erreur lors de l’enregistrement de la commande." };
    }

    console.log("✅ Commande enregistrée avec succès:", data);

    clearCart();

    return { success: true, data };
  } catch (err) {
    console.error("Erreur inattendue:", err);
    return { success: false, message: "Erreur inattendue lors de la commande." };
  }
};



  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // ✅ Save the order in Supabase
  await saveOrder(formData, cart, subtotal, deliveryFee, total);

  // ✅ Optional callback after placing order
  onPlaceOrder?.(formData);

  // ✅ Show confirmation message
  setIsConfirmed(true);
};

if (isConfirmed) {
  return (
    <div className="checkout-page container my-5">

      {/* Success Icon */}
      <div className="text-center mb-4">
        <div
          style={{
            fontSize: "4.5rem",
            color: "#FF1FB2",
            fontWeight: "bold",
          }}
        >
          ✓
        </div>
        <h2 className="fw-bold" style={{ color: "#FF1FB2" }}>
          Commande confirmée !
        </h2>

        <p className="text-muted">
          Merci pour votre commande 🐾 Nous sommes en train de la vérifier.
        </p>
        <p className="text-muted">
          Un e-mail vous sera envoyé prochainement. Vérifiez votre boîte mail.
        </p>
      </div>

      {/* Cards Section */}
      <div className="row justify-content-center g-4">

        {/* Retrait en magasin */}
        <div className="col-md-6">
          <div
            className="p-4 shadow rounded"
            style={{
              borderTop: "5px solid #FF1FB2",
              background: "#fff",
            }}
          >
            <h4 className="fw-bold" style={{ color: "#FF1FB2" }}>
              🐾 Retrait en magasin
            </h4>
            <p className="mt-2">
              Retrait disponible sous <strong>72h</strong>, si certains articles sont indisponibles.
            </p>
          </div>
        </div>

        {/* Expédition Standard */}
        <div className="col-md-6">
          <div
            className="p-4 shadow rounded"
            style={{
              borderTop: "5px solid #FF1FB2",
              background: "#fff",
            }}
          >
            <h4 className="fw-bold" style={{ color: "#FF1FB2" }}>
              🐾 Expédition Standard
            </h4>
            <p className="mt-2">
              Expédition sous <strong>24h ouvrées</strong> (Lun–Ven, hors jours fériés).
            </p>
          </div>
        </div>

        {/* Livraison Express */}
        <div className="col-12">
          <div
            className="p-4 shadow rounded"
            style={{
              borderTop: "5px solid #FF1FB2",
              background: "#fff",
            }}
          >
            <h4 className="fw-bold" style={{ color: "#FF1FB2" }}>
              🐾 Livraison Express
            </h4>

            <p className="mb-1">
              <strong>16 DT</strong> pour toute commande.
            </p>

            <p className="text-muted">
              Disponible uniquement sur certains articles et sous réserve de disponibilité.
            </p>

            <p className="mt-2">
              Un supplément de <strong>15 DT</strong> est appliqué pour +40kg.
            </p>
          </div>
        </div>

        {/* Livraison par zone + poids */}
        <div className="col-12">
          <div
            className="p-4 shadow rounded"
            style={{
              borderTop: "5px solid #FF1FB2",
              background: "#fff",
            }}
          >
            <h4 className="fw-bold" style={{ color: "#FF1FB2" }}>
              🐾 Tarifs de livraison par région & poids
            </h4>

            <ul className="mt-3" style={{ lineHeight: "1.8" }}>

              <li><strong>-20kg :</strong> Tunis & Ariana : 7dt • Ben Arous : 10dt</li>

              <li><strong>+20kg :</strong> Tunis & Ariana : 10dt • Ben Arous : 13dt</li>

              <li>
                <strong>Autres gouvernorats :</strong>
                <br />
                → 8dt (-10kg) <br />
                → 14dt (10–20kg) <br />
                → 18dt (20–40kg)
              </li>

            </ul>
          </div>
        </div>

      </div>
    </div>
  );
}


  // Handle submit
//  const handleSubmit = async (e) => {
//   e.preventDefault();

//   // Save the order first
//   await saveOrder(formData, cart, subtotal, deliveryFee, total);

//   // Construct the HTML email message
//   const emailHTML = `
//     <div style="font-family: system-ui, sans-serif, Arial; font-size: 14px; color: #212121">
//       <div style="max-width: 600px; margin: auto">
//         <div
//           style="
//             text-align: center;
//             background-color: #FF11A1;
//             padding: 32px 16px;
//             border-radius: 32px 32px 0 0;
//           "
//         >
//           <a style="text-decoration: none; outline: none" href="#" target="_blank">
//             <img
//               style="height: 32px; vertical-align: middle"
//               height="32px"
//               src="https://aujdasturxpqlzqjbztf.supabase.co/storage/v1/object/public/animalia/favicon.png"
//               alt="logo"
//             />
//           </a>
//         </div>
//         <div style="padding: 32px; text-align: center">
//           <h1 style="font-size: 22px; margin-bottom: 16px">🐾 Merci pour votre commande !</h1>
//           <p style="font-size: 16px">
//             Commande passée avec succès. Nous allons vous communiquer lorsque votre commande est confirmée.
//           </p>
//         </div>
//         <div
//           style="
//             text-align: center;
//             background-color: #FF11A1;
//             padding: 16px;
//             border-radius: 0 0 32px 32px;
//           "
//         >
//           <p style="margin: 0; font-size: 12px; color: #fff">© 2025 Animalia</p>
//         </div>
//       </div>
//     </div>
//   `;

//   // Construct the email content
//   const emailContent = {
//     order_id: formData.id,
//     name: `${formData.nom} ${formData.prenom}`,
//     email: formData.email,
//     cost_shipping: deliveryFee.toFixed(3),
//     cost_total: total.toFixed(3),
//     message_html: emailHTML, // This assumes your template supports this variable
//   };

//   // Send the email
//   emailjs.send(
//     'service_9tb3fmc',
//     'template_ae296tf',
//     emailContent,
//     'h53ZUGcAo9qIWRJs6'
//   ).then(
//     (response) => {
//       console.log("Email sent successfully:", response.status, response.text);
//     },
//     (error) => {
//       console.error("Email failed to send:", error);
//     }
//   );

//   // Optional: trigger callback
//   onPlaceOrder?.(formData);

//   // Show confirmation
//   setIsConfirmed(true);
// };

//   if (isConfirmed) {
//     return (
//       <div className="checkout-page container text-center" style={{ paddingTop: "2rem" }}>
//         <div style={{ fontSize: "4rem", color: "green" }}>✓</div>
//         <h2>Commande confirmée !</h2>
// <p>Merci pour votre commande. Nous sommes en train de la vérifier. </p>
// <p>  Un e-mail vous sera envoyé prochainement. N'oubliez pas de consulter votre boîte mail.</p>
//      {/* <div
//   style={{
//     maxWidth: "480px",
//     margin: "2rem auto",
//     padding: "1.5rem 2rem",
//     borderRadius: "12px",
//     boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
//     backgroundColor: "#ffffff",
//     textAlign: "left",
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//   }} */}
// {/* > */}
//   {/* <h4 style={{ marginBottom: "1rem", borderBottom: "2px solid #4caf50", paddingBottom: "0.5rem", color: "#4caf50" }}>
//     Facture
//   </h4>
//   <p><strong>Nom:</strong> {formData.nom} {formData.prenom}</p>
//   <p>
//     <strong>Adresse:</strong> {formData.adresse}, {formData.ville}, {formData.gouvernorat}, {formData.codePostal}, Tunisie
//   </p>
//   <p><strong>Téléphone 1:</strong> {formData.tel1}</p>
//   {formData.tel2 && <p><strong>Téléphone 2:</strong> {formData.tel2}</p>}
//   <p><strong>Email:</strong> {formData.email}</p>
//   <hr style={{ margin: "1.5rem 0" }} /> */}
//   {/* <p><strong>Sous-total:</strong> {subtotal.toFixed(3)} DT</p>
//   <p><strong>Frais de livraison:</strong> {deliveryFee.toFixed(3)} DT</p>
//   <p style={{ fontWeight: "700", fontSize: "1.1rem", marginTop: "1rem" }}>
//     <strong>Total:</strong> {total.toFixed(3)} DT
//   </p> 
//   </div>*/}

//       </div>
//     );
    
//   }
const renderVariation = (item) => {
  if (!item.selectedGout && !item.selectedWeight) return null;

  return (
    <div
      style={{
        fontSize: "12px",
        color: "#777",
        marginTop: "2px",
        marginBottom: "4px",
      }}
    >
      {item.selectedGout && <span>Goût : {item.selectedGout}</span>}
      {item.selectedGout && item.selectedWeight && <span> • </span>}
      {item.selectedWeight && <span>Poids : {item.selectedWeight}</span>}
    </div>
  );
};

  return (
<div className="checkout-page container" style={{ paddingTop: "60px", paddingBottom: "230px" }}>
      <h2>Paiement à la Livraison</h2>

      {cart.length === 0 ? (
        <p>Votre panier est vide.</p>
      ) : (
        <>
      <ul className="list-group mb-4">
  {cart.map((item) => {
    const price = parsePrice(item.selectedPrice);
    const qty = Number(item.quantity) || 1;
    return (
<li
  key={item.id}
  className="list-group-item d-flex justify-content-between align-items-center"
>
  <div className="d-flex align-items-center">
    <img
      src={item.image}
      alt={item.name}
      width="100px"
      height="60"
      style={{
        objectFit: "cover",
        borderRadius: "8px",
                marginLeft: window.innerWidth < 768 ? "75px" : "10px", // shift text slightly left on mobile

      }}
    />
    <div
      style={{
        marginLeft: window.innerWidth < 768 ? "-65px" : "10px", // shift text slightly left on mobile
      }}
    >
      <div>{item.name}</div>
      {renderVariation(item)}
      <small className="text-muted">
        {qty} × {formatPrice(price)} DT
      </small>
    </div>
  </div>
  <span style={{ fontWeight: "bold" }}>
    {formatPrice(price * qty)} DT
  </span>
</li>

    );
  })}

<li className="list-group-item">
  <label className="fw-bold mb-3">Mode de livraison</label>
  <div className="row g-3">
    {/* Livraison à domicile */}
    <div className="col-md-6">
      <div
        onClick={() => setDeliveryMethod("domicile")}
        style={{
          border: deliveryMethod === "domicile" ? "2px solid #FF1FB2" : "1px solid #ddd",
          borderRadius: "8px",
          padding: "15px",
          cursor: "pointer",
          textAlign: "center",
          backgroundColor: deliveryMethod === "domicile" ? "#fff5fb" : "#fff",
          transition: "all 0.3s ease",
        }}
      >
        <div style={{ fontSize: "2rem", marginBottom: "8px" }}>🚚</div>
        <div style={{ fontWeight: "600", marginBottom: "4px" }}>
          Livraison à domicile
        </div>
        <small className="text-muted">8.000 DT</small>
      </div>
    </div>

    {/* Retrait en magasin */}
    <div className="col-md-6">
      <div
        onClick={() => setDeliveryMethod("magasin")}
        style={{
          border: deliveryMethod === "magasin" ? "2px solid #FF1FB2" : "1px solid #ddd",
          borderRadius: "8px",
          padding: "15px",
          cursor: "pointer",
          textAlign: "center",
          backgroundColor: deliveryMethod === "magasin" ? "#fff5fb" : "#fff",
          transition: "all 0.3s ease",
        }}
      >
        <div style={{ fontSize: "2rem", marginBottom: "8px" }}>🏪</div>
        <div style={{ fontWeight: "600", marginBottom: "4px" }}>
          Retrait en magasin
        </div>
        <small className="text-muted">Gratuit</small>
      </div>
    </div>
  </div>
</li>
  <li className="list-group-item d-flex justify-content-between">
    <span>Sous-total</span>
    <span>{formatPrice(subtotal)} DT</span>
  </li>

  <li className="list-group-item d-flex justify-content-between">
    <span>Frais de livraison</span>
    <span>{formatPrice(deliveryFee)} DT</span>
  </li>

  <li className="list-group-item d-flex justify-content-between font-weight-bold">
    <span>Total</span>
    <span>{formatPrice(total)} DT</span>
  </li>
</ul>


          {/* Form */}
          <form onSubmit={handleSubmit} className="mb-3">
            <div className="row mb-2">
              <div className="col-md-6">
                <label>Nom</label>
                <input
                  type="text"
                  name="nom"
                  className="form-control"
                  value={formData.nom}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <label>Prénom</label>
                <input
                  type="text"
                  name="prenom"
                  className="form-control"
                  value={formData.prenom}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="mb-2">
              <label>Adresse complète</label>
              <input
                type="text"
                name="adresse"
                className="form-control"
                value={formData.adresse}
                onChange={handleChange}
                required
              />
            </div>

            <div className="row mb-2">
              <div className="col-md-4">
                <label>Ville</label>
                <input
                  type="text"
                  name="ville"
                  className="form-control"
                  value={formData.ville}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-4">
                <label>Gouvernorat/Province</label>
                <input
                  type="text"
                  name="gouvernorat"
                  className="form-control"
                  value={formData.gouvernorat}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-4">
                <label>Code postal</label>
                <input
                  type="text"
                  name="codePostal"
                  className="form-control"
                  value={formData.codePostal}
                  onChange={handleChange}
                  pattern="\d{4}"
                  title="Code postal Tunisien à 4 chiffres"
                  required
                />
              </div>
            </div>

            <div className="row mb-2">
              <div className="col-md-6">
                <label>Numéro de téléphone 1</label>
                <input
                  type="tel"
                  name="tel1"
                  className="form-control"
                  value={formData.tel1}
                  onChange={handleChange}
                  pattern="^(?:\+216)?[2459]\d{7}$"
                  title="Numéro Tunisien valide"
                  required
                />
              </div>
              <div className="col-md-6">
                <label>Numéro de téléphone 2 (optionnel)</label>
                <input
                  type="tel"
                  name="tel2"
                  className="form-control"
                  value={formData.tel2}
                  onChange={handleChange}
                  pattern="^(?:\+216)?[2459]\d{7}$"
                  title="Numéro Tunisien valide"
                />
              </div>
            </div>

            <div className="mb-3">
              <label>Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <button type="submit" className="btn btn-success btn-block">
              Confirmer la commande
            </button>
          </form>
        </>
      )}
    </div>
  );
};

export default CheckoutPage;
